/* eslint-disable sort-keys */

import { lazy, Suspense } from 'react'

// assets/logos
const Apple = lazy(() => import('./assets/logos/AppleLogo'))
const EdubookFavBook = lazy(() => import('./assets/logos/EdubookFavBook'))
const EdubookFavtext = lazy(() => import('./assets/logos/EdubookFavText'))
const EdubookLandscapeBlack = lazy(
  () => import('./assets/logos/EdubookLandscapeBlack')
)
const EdubookLandscapeGradient = lazy(
  () => import('./assets/logos/EdubookLandscapeGradient')
)
const EdubookLandscapeOrange = lazy(
  () => import('./assets/logos/EdubookLandscapeOrange')
)
const EdubookLearning = lazy(() => import('./assets/logos/EdubookLearning'))
const EdubookPublishing = lazy(() => import('./assets/logos/EdubookPublishing'))
const EdubookSquareBlack = lazy(
  () => import('./assets/logos/EdubookSquareBlack')
)
const EdubookSquareGradient = lazy(
  () => import('./assets/logos/EdubookSquareGradient')
)
const EdubookSquareOrange = lazy(
  () => import('./assets/logos/EdubookSquareOrange')
)
const Google = lazy(() => import('./assets/logos/GoogleLogo'))
const MoodleLogo = lazy(() => import('./assets/logos/MoodleLogo'))

// assets/ilustrations
const IlustrationsAskForInformation = lazy(
  () => import('./assets/ilustrations/AskForInformation')
)
const IlustrationsCenters = lazy(() => import('./assets/ilustrations/Centers'))
const IlustrationsDraw = lazy(() => import('./assets/ilustrations/Draw'))
const IlustrationsError404 = lazy(
  () => import('./assets/ilustrations/Error404')
)
const IlustrationsHappyMobile = lazy(
  () => import('./assets/ilustrations/HappyMobile')
)
const IlustrationsPaint = lazy(() => import('./assets/ilustrations/Paint'))
const IlustrationsPencilHand = lazy(
  () => import('./assets/ilustrations/PencilHand')
)
const IlustrationsRegistryStart = lazy(
  () => import('./assets/ilustrations/RegistryStart')
)
const IlustrationsShow = lazy(() => import('./assets/ilustrations/Show'))
const IlustrationsStudentBoy = lazy(
  () => import('./assets/ilustrations/StudentBoy')
)
const IlustrationsTeacherHands = lazy(
  () => import('./assets/ilustrations/TeacherHands')
)
const IlustrationsThink = lazy(() => import('./assets/ilustrations/Think'))

// assets/interface
const Activities = lazy(() => import('./assets/interface/Activities'))
const ActivityClosed = lazy(() => import('./assets/interface/ActivityClosed'))
const ActivityOpen = lazy(() => import('./assets/interface/ActivityOpen'))
const Add = lazy(() => import('./assets/interface/Add'))
const AddGroup = lazy(() => import('./assets/interface/AddGroup'))
const AddUser = lazy(() => import('./assets/interface/AddUser'))
const Audio = lazy(() => import('./assets/interface/Audio'))
const AudioPlayer = lazy(() => import('./assets/interface/AudioPlayer'))
const Back = lazy(() => import('./assets/interface/Back'))
const Blog = lazy(() => import('./assets/interface/Blog'))
const Bookmark = lazy(() => import('./assets/interface/Bookmark'))
const Books = lazy(() => import('./assets/interface/Books'))
const Calendar = lazy(() => import('./assets/interface/Calendar'))
const Catalogue = lazy(() => import('./assets/interface/Catalogue'))
const Chatbot = lazy(() => import('./assets/interface/Chatbot'))
const ChevronDown = lazy(() => import('./assets/interface/ChevronDown'))
const ChevronLeft = lazy(() => import('./assets/interface/ChevronLeft'))
const ChevronRight = lazy(() => import('./assets/interface/ChevronRight'))
const ChevronUp = lazy(() => import('./assets/interface/ChevronUp'))
const ChevronWeb = lazy(() => import('./assets/interface/ChevronWeb'))
const Class = lazy(() => import('./assets/interface/Class'))
const Clock = lazy(() => import('./assets/interface/Clock'))
const Close = lazy(() => import('./assets/interface/Close'))
const Clue = lazy(() => import('./assets/interface/Clue'))
const Comment = lazy(() => import('./assets/interface/Comment'))
const Content = lazy(() => import('./assets/interface/Content'))
const Copy = lazy(() => import('./assets/interface/Copy'))
const Dashboard = lazy(() => import('./assets/interface/Dashboard'))
const Delete = lazy(() => import('./assets/interface/Delete'))
const Delivery = lazy(() => import('./assets/interface/Delivery'))
const Dislike = lazy(() => import('./assets/interface/Dislike'))
const Download = lazy(() => import('./assets/interface/Download'))
const Downloaded = lazy(() => import('./assets/interface/Downloaded'))
const Drag = lazy(() => import('./assets/interface/Drag'))
const Duplicate = lazy(() => import('./assets/interface/Duplicate'))
const Edit = lazy(() => import('./assets/interface/Edit'))
const EmptyFolder = lazy(() => import('./assets/interface/EmptyFolder'))
const Error = lazy(() => import('./assets/interface/Error'))
const Exams = lazy(() => import('./assets/interface/Exams'))
const Exam = lazy(() => import('./assets/interface/Exam'))
const ExternalLink = lazy(() => import('./assets/interface/ExternalLink'))
const Family = lazy(() => import('./assets/interface/Family'))
const FavoriteOff = lazy(() => import('./assets/interface/FavoriteOff'))
const FavoriteOn = lazy(() => import('./assets/interface/FavoriteOn'))
const File = lazy(() => import('./assets/interface/File'))
const Filters = lazy(() => import('./assets/interface/Filters'))
const FontSize = lazy(() => import('./assets/interface/FontSize'))
const FullScreenExit = lazy(() => import('./assets/interface/FullScreenExit'))
const FullScreenOpen = lazy(() => import('./assets/interface/FullScreenOpen'))
const Grades = lazy(() => import('./assets/interface/Grades'))
const GradeBook = lazy(() => import('./assets/interface/GradeBook'))
const HamMenu = lazy(() => import('./assets/interface/HamMenu'))
const Help = lazy(() => import('./assets/interface/Help'))
const Hide = lazy(() => import('./assets/interface/Hide'))
const Highlight = lazy(() => import('./assets/interface/Highlight'))
const Home = lazy(() => import('./assets/interface/Home'))
const Image = lazy(() => import('./assets/interface/Image'))
const Index = lazy(() => import('./assets/interface/Index'))
const Info = lazy(() => import('./assets/interface/Info'))
const Like = lazy(() => import('./assets/interface/Like'))
const Link = lazy(() => import('./assets/interface/Link'))
const Loading = lazy(() => import('./assets/interface/Loading'))
const Lock = lazy(() => import('./assets/interface/Lock'))
const LogOut = lazy(() => import('./assets/interface/LogOut'))
const Menu = lazy(() => import('./assets/interface/Menu'))
const Mic = lazy(() => import('./assets/interface/Mic'))
const MobileMenu = lazy(() => import('./assets/interface/MobileMenu'))
const More = lazy(() => import('./assets/interface/More'))
const Multimedia = lazy(() => import('./assets/interface/Multimedia'))
const NewComment = lazy(() => import('./assets/interface/NewComment'))
const Next = lazy(() => import('./assets/interface/Next'))
const Noocs = lazy(() => import('./assets/interface/Noocs'))
const Note = lazy(() => import('./assets/interface/Note'))
const Notification = lazy(() => import('./assets/interface/Notification'))
const NotificationOn = lazy(() => import('./assets/interface/NotificationOn'))
const Offline = lazy(() => import('./assets/interface/Offline'))
const Online = lazy(() => import('./assets/interface/Online'))
const Pages = lazy(() => import('./assets/interface/Pages'))
const Pause = lazy(() => import('./assets/interface/Pause'))
const Payment = lazy(() => import('./assets/interface/Payment'))
const PencilCase = lazy(() => import('./assets/interface/PencilCase'))
const Pending = lazy(() => import('./assets/interface/Pending'))
const Play = lazy(() => import('./assets/interface/Play'))
const PlayVideo = lazy(() => import('./assets/interface/PlayVideo'))
const Premium = lazy(() => import('./assets/interface/Premium'))
const Projects = lazy(() => import('./assets/interface/Projects'))
const Reader = lazy(() => import('./assets/interface/Reader'))
const Resources = lazy(() => import('./assets/interface/Resources'))
const Responsive = lazy(() => import('./assets/interface/Responsive'))
const Save = lazy(() => import('./assets/interface/Save'))
const School = lazy(() => import('./assets/interface/School'))
const Search = lazy(() => import('./assets/interface/Search'))
const Send = lazy(() => import('./assets/interface/Send'))
const Share = lazy(() => import('./assets/interface/Share'))
const Show = lazy(() => import('./assets/interface/Show'))
const Slide = lazy(() => import('./assets/interface/Slide'))
const Students = lazy(() => import('./assets/interface/Students'))
const Success = lazy(() => import('./assets/interface/Success'))
const Support = lazy(() => import('./assets/interface/Support'))
const Teacher = lazy(() => import('./assets/interface/Teacher'))
const Template = lazy(() => import('./assets/interface/Template'))
const TextBox = lazy(() => import('./assets/interface/TextBox'))
const Tools = lazy(() => import('./assets/interface/Tools'))
const Training = lazy(() => import('./assets/interface/Training'))
const Turn = lazy(() => import('./assets/interface/Turn'))
const Unlink = lazy(() => import('./assets/interface/Unlink'))
const Update = lazy(() => import('./assets/interface/Update'))
const User = lazy(() => import('./assets/interface/User'))
const UserValidation = lazy(() => import('./assets/interface/UserValidation'))
const Validate = lazy(() => import('./assets/interface/Validate'))
const Videos = lazy(() => import('./assets/interface/Videos'))
const Warning = lazy(() => import('./assets/interface/Warning'))
const ZoomIN = lazy(() => import('./assets/interface/ZoomIn'))
const ZoomOut = lazy(() => import('./assets/interface/ZoomOut'))

// assets/subjects
const Biologia = lazy(() => import('./assets/subject/Biologia'))
const Default = lazy(() => import('./assets/subject/Default'))
const Economics = lazy(() => import('./assets/subject/Economics'))
const EdFisica = lazy(() => import('./assets/subject/EdFisica'))
const Fisica = lazy(() => import('./assets/subject/Fisica'))
const Geografia = lazy(() => import('./assets/subject/Geografia'))
const Globalizado = lazy(() => import('./assets/subject/Globalizado'))
const Historia = lazy(() => import('./assets/subject/Historia'))
const HistoriaArte = lazy(() => import('./assets/subject/HistoriaArte'))
const Informatica = lazy(() => import('./assets/subject/Informatica'))
const Lengua = lazy(() => import('./assets/subject/Lengua'))
const Literatura = lazy(() => import('./assets/subject/Literatura'))
const Mates = lazy(() => import('./assets/subject/Mates'))
const Musica = lazy(() => import('./assets/subject/Musica'))
const Philosophy = lazy(() => import('./assets/subject/Philosophy'))
const Plastica = lazy(() => import('./assets/subject/Plastica'))
const Quimica = lazy(() => import('./assets/subject/Quimica'))
const Religion = lazy(() => import('./assets/subject/Religion'))
const Teatro = lazy(() => import('./assets/subject/Teatro'))
const Technology = lazy(() => import('./assets/subject/Technology'))
const Valores = lazy(() => import('./assets/subject/Valores'))

// assets/content
const ActColaborativa = lazy(() => import('./assets/content/ActColaborativa'))
const ActCompetencial = lazy(() => import('./assets/content/ActCompetencial'))
const BibliotecaNube = lazy(() => import('./assets/content/BibliotecaNube'))
const Detectives = lazy(() => import('./assets/content/Detectives'))
const Dictado = lazy(() => import('./assets/content/Dictado'))
const Done = lazy(() => import('./assets/content/Done'))
const Estrella = lazy(() => import('./assets/content/Estrella'))
const GoogleClassroom = lazy(() => import('./assets/content/GoogleClassroom'))
const Gym = lazy(() => import('./assets/content/Gym'))
const InProgress = lazy(() => import('./assets/content/InProgress'))
const Location = lazy(() => import('./assets/content/Location'))
const NoMeDigas = lazy(() => import('./assets/content/NoMeDigas'))
const ODS = lazy(() => import('./assets/content/ODS'))
const PistaReto = lazy(() => import('./assets/content/PistaReto'))
const Question = lazy(() => import('./assets/content/Question'))
const Reto = lazy(() => import('./assets/content/Reto'))
const STEAM = lazy(() => import('./assets/content/STEAM'))
const Tecnologia = lazy(() => import('./assets/content/Tecnologia'))
const TIC = lazy(() => import('./assets/content/TIC'))
const Tiching = lazy(() => import('./assets/content/Tiching'))
const ToDo = lazy(() => import('./assets/content/ToDo'))
const VideoPlayer = lazy(() => import('./assets/content/VideoPlayer'))

export const icons = {
  // logos
  apple: Apple,
  edubookFavBook: EdubookFavBook,
  edubookFavText: EdubookFavtext,
  edubookLandscapeBlack: EdubookLandscapeBlack,
  edubookLandscapeGradient: EdubookLandscapeGradient,
  edubookLandscapeOrange: EdubookLandscapeOrange,
  edubookLearning: EdubookLearning,
  edubookPublishing: EdubookPublishing,
  edubookSquareBlack: EdubookSquareBlack,
  edubookSquareGradient: EdubookSquareGradient,
  edubookSquareOrange: EdubookSquareOrange,
  google: Google,
  moodleLogo: MoodleLogo,
  // ilustrations
  ilustrationsAskForInformation: IlustrationsAskForInformation,
  ilustrationsCenters: IlustrationsCenters,
  ilustrationsDraw: IlustrationsDraw,
  ilustrationsError404: IlustrationsError404,
  ilustrationsHappyMobile: IlustrationsHappyMobile,
  ilustrationsPaint: IlustrationsPaint,
  ilustrationsPencilHand: IlustrationsPencilHand,
  ilustrationsRegistryStart: IlustrationsRegistryStart,
  ilustrationsShow: IlustrationsShow,
  ilustrationsStudentBoy: IlustrationsStudentBoy,
  ilustrationsTeacherHands: IlustrationsTeacherHands,
  ilustrationsThink: IlustrationsThink,
  // interface
  activities: Activities,
  activityClosed: ActivityClosed,
  activityOpen: ActivityOpen,
  add: Add,
  addGroup: AddGroup,
  addUser: AddUser,
  audio: Audio,
  audioPlayer: AudioPlayer,
  back: Back,
  blog: Blog,
  bookmark: Bookmark,
  books: Books,
  calendar: Calendar,
  catalogue: Catalogue,
  chatbot: Chatbot,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  chevronWeb: ChevronWeb,
  class: Class,
  clock: Clock,
  close: Close,
  clue: Clue,
  comment: Comment,
  content: Content,
  copy: Copy,
  dashboard: Dashboard,
  delete: Delete,
  delivery: Delivery,
  dislike: Dislike,
  download: Download,
  downloaded: Downloaded,
  drag: Drag,
  duplicate: Duplicate,
  edit: Edit,
  emptyFolder: EmptyFolder,
  error: Error,
  exam: Exam,
  exams: Exams,
  externalLink: ExternalLink,
  family: Family,
  favoriteOff: FavoriteOff,
  favoriteOn: FavoriteOn,
  file: File,
  filters: Filters,
  fontSize: FontSize,
  fullScreenExit: FullScreenExit,
  fullScreenOpen: FullScreenOpen,
  grades: Grades,
  gradeBook: GradeBook,
  hamMenu: HamMenu,
  help: Help,
  hide: Hide,
  highlight: Highlight,
  home: Home,
  image: Image,
  index: Index,
  info: Info,
  like: Like,
  link: Link,
  loading: Loading,
  lock: Lock,
  logOut: LogOut,
  menu: Menu,
  mic: Mic,
  mobileMenu: MobileMenu,
  more: More,
  multimedia: Multimedia,
  newComment: NewComment,
  next: Next,
  noocs: Noocs,
  note: Note,
  notification: Notification,
  notificationOn: NotificationOn,
  offline: Offline,
  online: Online,
  pages: Pages,
  pause: Pause,
  payment: Payment,
  pencilCase: PencilCase,
  pending: Pending,
  play: Play,
  playVideo: PlayVideo,
  premium: Premium,
  projects: Projects,
  reader: Reader,
  resources: Resources,
  responsive: Responsive,
  save: Save,
  school: School,
  search: Search,
  send: Send,
  share: Share,
  show: Show,
  slide: Slide,
  students: Students,
  success: Success,
  support: Support,
  teacher: Teacher,
  template: Template,
  textBox: TextBox,
  tools: Tools,
  training: Training,
  turn: Turn,
  unlink: Unlink,
  update: Update,
  user: User,
  userValidation: UserValidation,
  validate: Validate,
  videos: Videos,
  warning: Warning,
  zoomIn: ZoomIN,
  zoomOut: ZoomOut,

  // subjects
  biologia: Biologia,
  default: Default,
  economics: Economics,
  edFisica: EdFisica,
  fisica: Fisica,
  geografia: Geografia,
  globalizado: Globalizado,
  historia: Historia,
  historiaArte: HistoriaArte,
  informatica: Informatica,
  lengua: Lengua,
  literatura: Literatura,
  mates: Mates,
  musica: Musica,
  philosophy: Philosophy,
  plastica: Plastica,
  quimica: Quimica,
  religion: Religion,
  teatro: Teatro,
  technology: Technology,
  valores: Valores,
  // content
  actColaborativa: ActColaborativa,
  actCompetencial: ActCompetencial,
  bibliotecaNube: BibliotecaNube,
  detectives: Detectives,
  dictado: Dictado,
  done: Done,
  estrella: Estrella,
  googleClassroom: GoogleClassroom,
  gym: Gym,
  inProgress: InProgress,
  location: Location,
  noMeDigas: NoMeDigas,
  ods: ODS,
  pistaReto: PistaReto,
  question: Question,
  reto: Reto,
  steam: STEAM,
  tecnologia: Tecnologia,
  tic: TIC,
  tiching: Tiching,
  toDo: ToDo,
  videoPlayer: VideoPlayer,
}

// should get the keys from the icons object
export type IconTypes = keyof typeof icons

export interface IconProps {
  /**
   * Css class to override default styles
   */
  className?: string
  /**
   * A text to indicate data test id.
   */
  dataTestId?: string
  /**
   * Text to indicate the fill color of the icon
   */
  fill?: string
  /**
   * A string to indicate what icon we want use.
   */
  icon: IconTypes
  /**
   * A text to indicate the checkbox id.
   */
  id?: string
  /**
   * A number to indicate the height icon.
   */
  height?: number
  /**
   * A string to indicate the color icon.
   */
  stroke?: string
  /**
   * A string to indicate title icon.
   */
  title?: string
  /**
   * A number to indicate the width icon.
   */
  width?: number
}

const Icon: (props: IconProps) => JSX.Element = ({
  className,
  dataTestId,
  fill,
  height,
  icon,
  id,
  stroke,
  title = icon,
  width,
}: IconProps) => {
  const SpecificIcon = icons[icon]

  return (
    <Suspense fallback={null}>
      <SpecificIcon
        className={className}
        dataTestId={dataTestId}
        fill={fill}
        height={height}
        icon={icon}
        id={id}
        stroke={stroke}
        title={title}
        width={width}
      />
    </Suspense>
  )
}

export default Icon
